import { render, staticRenderFns } from "./SecondaryScrapers.vue?vue&type=template&id=3c33aba7&"
import script from "./SecondaryScrapers.vue?vue&type=script&lang=js&"
export * from "./SecondaryScrapers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports